import acceptanceCreateManual from './acceptance-create-manual.json';
import acceptanceCreateWithInvoices from './acceptance-create-with-invoices.json';
import acceptanceCreateWithTemplate from './acceptance-create-with-template.json';
import acceptanceCreate from './acceptance-create.json';
import acceptanceView from './acceptance-view.json';
import acceptances from './acceptances.json';
import classificationsOfUnits from './classifications-of-units.json';
import commodityReports from './commodity-reports.json';
import dashboard from './dashboard.json';
import disassembliesCreate from './disassemblies-create.json';
import disassembliesView from './disassemblies-view.json';
import disassemblies from './disassemblies.json';
import divisionsCreate from './divisions-create.json';
import divisionsUpdate from './divisions-update.json';
import divisions from './divisions.json';
import equipmentsCreate from './equipments-create.json';
import equipmentsView from './equipments-view.json';
import equipments from './equipments.json';
import inventoriesCreate from './inventories-create.json';
import inventoriesReceiptByInventory from './inventories-receipt-by-inventory.json';
import inventoriesView from './inventories-view.json';
import inventoriesWriteOffsByInventory from './inventories-write-offs-by-inventory.json';
import inventories from './inventories.json';
import materialReports from './material-reports.json';
import movementsCreate from './movements-create.json';
import movementsView from './movements-view.json';
import movements from './movements.json';
import nomenclaturesPrices from './nomenclatures-prices.json';
import nomenclatures from './nomenclatures.json';
import operationView from './operation-view.json';
import operations from './operations.json';
import remains from './remains.json';
import salesByNomenclature from './sales-by-nomenclature.json';
import warehousesCreate from './warehouses-create.json';
import warehousesUpdate from './warehouses-update.json';
import warehouses from './warehouses.json';
import writeOffsCreate from './write-offs-create.json';
import writeOffsView from './write-offs-view.json';
import writeOffs from './write-offs.json';
const warehousesModule = {
   'warehouse-acceptance-create': acceptanceCreate,
   'warehouse-acceptance-create-manual': acceptanceCreateManual,
   'warehouse-acceptance-create-with-invoices': acceptanceCreateWithInvoices,
   'warehouse-acceptance-create-with-template': acceptanceCreateWithTemplate,
   'warehouse-acceptance-view': acceptanceView,
   'warehouse-acceptances': acceptances,
   'warehouse-classifications-of-units': classificationsOfUnits,
   'warehouse-commodity-reports': commodityReports,
   'warehouse-dashboard': dashboard,
   'warehouse-disassemblies': disassemblies,
   'warehouse-disassemblies-create': disassembliesCreate,
   'warehouse-disassemblies-view': disassembliesView,
   'warehouse-divisions': divisions,
   'warehouse-divisions-create': divisionsCreate,
   'warehouse-divisions-update': divisionsUpdate,
   'warehouse-equipments': equipments,
   'warehouse-equipments-create': equipmentsCreate,
   'warehouse-equipments-view': equipmentsView,
   'warehouse-inventories': inventories,
   'warehouse-inventories-create': inventoriesCreate,
   'warehouse-inventories-receipt-by-inventory': inventoriesReceiptByInventory,
   'warehouse-inventories-view': inventoriesView,
   'warehouse-material-reports': materialReports,
   'warehouse-movements': movements,
   'warehouse-movements-create': movementsCreate,
   'warehouse-movements-view': movementsView,
   'warehouse-nomenclatures': nomenclatures,
   'warehouse-nomenclatures-prices': nomenclaturesPrices,
   'warehouse-operation-view': operationView,
   'warehouse-operations': operations,
   'warehouse-remains': remains,
   'warehouse-sales-by-nomenclature': salesByNomenclature,
   'warehouse-warehouses': warehouses,
   'warehouse-warehouses-create': warehousesCreate,
   'warehouse-warehouses-update': warehousesUpdate,
   'warehouse-write-offs': writeOffs,
   'warehouse-write-offs-create': writeOffsCreate,
   'warehouse-write-offs-view': writeOffsView,
   'warehouse-inventories-write-offs-by-inventory':
      inventoriesWriteOffsByInventory,
};
export default warehousesModule;
